import { MergeOrUpdateStateAction } from '@tableau/vizportalclient-common-components';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { IError } from '~src/httpClient/serverApi/types/IError';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { Projects } from '~src/projects/resources/Projects';
import { CommonErrorCode, ProjectErrorCode } from '~src/ts/helpers/ErrorCodes';
import { L10n } from '~src/ts/L10n/L10n';
import { ToasterService, ToastType } from '~src/ts/services/ToasterService';

import { CreateProjectActionDialogProps, CreateProjectDialogBody,CreateProjectDialogProps, CreateProjectDialogState } from '../components/CreateProjectDialogBody';

export namespace CreateProjectAction {

  export const actionDisabled = (props: CreateProjectActionDialogProps, state: CreateProjectDialogState) => {
    return !state.isProjectDescriptionValid || state.name.trim().length === 0;
  };

  export function showCreateProjectDialog(parentId?: string): Promise<IResult> {
    const initialBodyProps: CreateProjectDialogProps = {
      parentId: parentId
    };

    const initialDialogState: CreateProjectDialogState = {
      name: '',
      description: '',
      errorMessage: undefined,
      isProjectDescriptionValid: true
    };

    const dialogInstance = openReactActionDialog<CreateProjectDialogProps, CreateProjectDialogState, IResult>({
      actionName: Messages.createProjectDialogSubmit(),
      action: createProject,
      actionDisabled,
      bodyComponent: CreateProjectDialogBody,
      dialogWidth: TabDialogWidth.width500px,
      dismissDialogOnActionFailed: false,
      initialBodyProps,
      initialDialogState,
      title: Messages.createProjectDialogTitle(),
    });

    return Promise.resolve(dialogInstance.result);
  }

  export async function createProject(
    props: CreateProjectActionDialogProps,
    dialogState: CreateProjectDialogState,
    updateDialogState: React.Dispatch<MergeOrUpdateStateAction<CreateProjectDialogState>>): Promise<IResult> {
    const result: IResult = await Projects.create(dialogState.name, dialogState.description, props.parentId).catch((reason: any) => {
      updateDialogState({ errorMessage: getErrorMessage([{ code: reason }]) });
      return Promise.reject();
    });
    if (result.errors && result.errors.length > 0) {
      const errorMessage = getErrorMessage(result.errors);
      updateDialogState({ errorMessage });
      return Promise.reject();
    }
    else {
      const successMessage = Messages.createProjectSuccess({ PROJECT_NAME: L10n.elideIfLong(dialogState.name) });
      ToasterService.instance.pop({ type: ToastType.Success, text: successMessage });
      Promise.resolve();
    }
  }

  function getErrorMessage(errors: IError[]) {
    switch (errors[0].code) {
      case ProjectErrorCode.ProjectNameAlreadyExists:
        return Messages.errorProjectNameAlreadyExists();
      case CommonErrorCode.CallingUserInsufficientPermissions:
        return Messages.projectCreationError_insufficientPermissions();
      default:
        return Messages.createProjectFailed();
    }
  }
}
